<template>
  <transition name="fade">
    <div
      v-if="essentialItems.length > 0"
      class="ec-Cart_Container container d-flex flex-wrap align-items-center justify-content-between"
    >
      <div class="ec-Cart_ButtonArea d-flex flex-column flex-wrap justify-content-between">
        <button
          class="btn btn-reset btn-icon shadow-none ec-Cart_CartText px-0 mb-sm-0"
          @click="toggleLineItems"
        >
          <div class="flex-grow-1 d-flex align-items-center pr-1">
            <span class="ec-Cart_Quantity pr-1">{{ essentialItemsQuantity }}</span> {{ selected }}
          </div>
          <ChevronUp
            class="ec-Cart_ExpandIcon svg-16"
            :class="showLineItems ? 'ec-Cart_ExpandIcon-rotated' : ''"
          />
        </button>
        <div v-if="showLineItems" class="scroll-wrapper">
          <div class="pb-2 scroll-content">
            <EssentialsCartLineItem
              v-for="lineItem in essentialItems"
              :key="lineItem.variant.id"
              :line-item="lineItem"
            />
          </div>
        </div>
      </div>
      <div class="ec-Cart_CartButton">
        <a
          v-if="checkoutPath"
          class="btn btn-block btn-icon justify-content-center btn-primary btn-lg ec-Cart_AddToCartButton"
          :href="checkoutPath"
          :disabled="isLoading"
        >
          <transition name="slowfade">
            <div v-show="isLoading" class="mr-1 spinner-border spinner-border-sm text-white"></div>
          </transition>
          <div>{{ add_to_cart }}</div>
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
import EssentialsCartLineItem from "./EssentialsCartLineItem";
import ChevronUp from "../../../../icons/atalanda/chevron-up.svg";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "EssentialsCartOverlay",
  components: { EssentialsCartLineItem, ChevronUp },
  props: {
    add_to_cart: {
      type: String,
      required: true,
    },
    selected: {
      type: String,
      required: true,
    },
    checkoutPath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showLineItems: false,
    };
  },
  computed: {
    ...mapGetters({
      essentialItems: "shoppingCart/getAllEssentialLineItems",
      essentialItemsQuantity: "shoppingCart/getAllEssentialLineItemsQuantity",
      isLoading: "shoppingCart/isLoading",
    }),
  },
  mounted() {
    this.fetchAllLineItems();
  },
  methods: {
    ...mapActions({
      fetchAllLineItems: "shoppingCart/fetchAllLineItems",
    }),
    toggleLineItems() {
      this.showLineItems = !this.showLineItems;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.ec-Cart_ExpandIcon {
  transition: transform $transition-duration;
}

.ec-Cart_ExpandIcon-rotated {
  transform: rotate(180deg);
}

.ec-Cart_ButtonArea {
  flex-basis: 100%;

  @media (min-width: $screen-sm-min) {
    flex-basis: auto;
  }
}

.ec-Cart_Container {
  background-color: $white;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: $spacer / 2;
  padding-top: 0;
  z-index: $zi-highest;
  box-shadow: $box-shadow-lg-hover;
  border-top: $width-border-thin solid $gray-200;
  border-top-left-radius: $border-radius-lg;
  border-top-right-radius: $border-radius-lg;

  @media (min-width: $screen-sm-min) {
    width: auto;
    padding: $spacer;
    left: $spacer / 2;
    right: $spacer / 2;
    bottom: $spacer / 2;
    border-radius: $border-radius-lg;
  }
}

.ec-Cart_Quantity {
  font-feature-settings: "tnum" 1;
}

.ec-Cart_CartButton {
  flex-basis: 100%;

  @media (min-width: $screen-sm-min) {
    flex-basis: auto;
    flex-shrink: 0;
    text-align: right;
  }
}

.ec-Cart_CartText {
  flex-grow: 1;
  flex-shrink: 0;
  font-family: $headings-font-family;
  font-size: $font-size-sm;
  display: flex;
  justify-content: space-between;

  @media (min-width: $screen-sm-min) {
    font-size: $h5-font-size;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration, transform $transition-duration;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY($spacer);
}

.slowfade-enter-active,
.slowfade-leave-active {
  transition: opacity $transition-duration;
  transition-timing-function: ease-in-out;
}

.slowfade-enter,
.slowfade-leave-to {
  opacity: 0;
}

.wrapper {
  position: fixed;
  width: auto;
  background: $white;
  top: $spacer / 4;
  right: $spacer / 4;
  left: $spacer / 4;
  z-index: $zi-highest;

  @media (min-width: $screen-sm-min) {
    position: absolute;
    top: 100%;
    right: 0;
    left: auto;
    width: $width-cart-overlay;
    margin: 0;

    &::before {
      z-index: $zi-highest;
      content: "";
      display: block;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid $white;
      position: absolute;
      right: 20px;
      top: -10px;
    }
  }
}

.scrolling-touch {
  -webkit-overflow-scrolling: touch;
}

.scroll-content {
  max-height: $max-height-cart-overlay-xs;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;

  @media (min-width: $screen-sm-min) {
    max-height: $max-height-cart-overlay;
  }
}

.scroll-wrapper {
  position: relative;

  &::after {
    background-image: linear-gradient(to bottom, rgba($white, 0), rgba($white, 1) 100%);
    bottom: 0;
    content: "";
    height: $spacer;
    pointer-events: none;
    position: absolute;
    width: 100%;
    z-index: $zi-higher;
  }
}
</style>
